import { CenteredContentBlog, ContentBlog, FooterText, Tag } from 'src/components/Blog/elements';
import { Facebook, Linkedin, Twitter } from 'src/components/Icons/Social Media';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { HeaderTitle, SubtitleDescription, TitleDescription } from 'src/components/Typography';

import { ButtonSocialMedia } from 'src/components/Founders/elements';
import Cookies from 'js-cookie';
import { GatsbyImage } from 'gatsby-plugin-image';
import Layout from '../components/Layout';
import React from 'react';
import { RelatedPosts } from 'src/components/Blog/index';
import { Section } from 'src/components/Section';
import StickyBox from 'react-sticky-box/dist/esnext';
import { TopbarStaticSpace } from 'src/components/Topbar';
import { graphql } from 'gatsby';
import { mediaQueries } from 'src/style/breakpoints';
import sizes from 'src/style/sizes';

const BlogPostTemplate = ({ data, location }) => {
  const post = data.markdownRemark;
  const edges = data.allMarkdownRemark.edges;
  const title = post.frontmatter.title;
  const preview = post.frontmatter.preview;
  const shareUrl =
    typeof window === 'undefined' ? process.env.GATSBY_API_URL + location.pathname : location.href;

  const dataLayer = (location, type) => {
    window.dataLayer.push({
      event: 'socialShare',
      businessType: 'B2B|B2C',
      type,
      location,
      pageType: 'article',
      pageName: title,
    });
  };

  return (
    <Layout
      pathname={location.pathname}
      businessType="B2C|B2B"
      pageName={title}
      pageType="article"
      metaTitle={`${title}`}
      metaDescription={preview}
      metaImage={post.frontmatter.featuredImage.childImageSharp.gatsbyImageData.src}
    >
      <TopbarStaticSpace />
      <Section
        theme="primary"
        css={{
          [mediaQueries.phoneOnly]: {
            height: sizes.purpleBgHeightMobile,
            paddingTop: 0,
          },
          [mediaQueries.tabletPortraitUp]: {
            height: sizes.purpleBgHeightTablet,
            paddingTop: 0,
          },
          [mediaQueries.tabletLandscapeUp]: {
            paddingTop: 40,
            height: sizes.purpleBgHeightDesktop,
          },
        }}
      >
        <GatsbyImage
          css={{
            borderRadius: 10,
            maxWidth: 970,
            width: '100%',
            margin: '0 auto',
            marginBottom: -200,
            [mediaQueries.phoneOnly]: {
              height: 200,
            },
            [mediaQueries.tabletPortraitUp]: {
              height: 400,
            },
            [mediaQueries.tabletLandscapeUp]: { height: 560 },
          }}
          image={post.frontmatter.featuredImage.childImageSharp.gatsbyImageData}
          alt={post.frontmatter.alt}
        />
      </Section>

      <Section theme="light">
        <div
          css={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            [mediaQueries.tabletLandscapeUp]: {
              marginLeft: 'auto',
              marginRight: 'auto',
            },
          }}
        >
          <StickyBox
            offsetTop={Cookies.get('bannerHidden') ? 100 : 130}
            css={{
              width: 70,
              marginTop: 80,
              display: 'none',
              [mediaQueries.tabletLandscapeUp]: {
                display: 'block',
              },
            }}
          >
            <ButtonSocialMedia css={{ marginBottom: 8 }}>
              <FacebookShareButton
                url={shareUrl}
                quote={title}
                className="button"
                onShareWindowClose={() => dataLayer('sticky', 'facebook')}
              >
                <Facebook />
              </FacebookShareButton>
            </ButtonSocialMedia>
            <ButtonSocialMedia css={{ marginBottom: 8 }}>
              <TwitterShareButton
                url={shareUrl}
                title={title}
                onShareWindowClose={() => dataLayer('sticky', 'twitter')}
              >
                <Twitter />
              </TwitterShareButton>
            </ButtonSocialMedia>
            <ButtonSocialMedia css={{ marginBottom: 8 }}>
              <LinkedinShareButton
                url={shareUrl}
                title={title}
                onShareWindowClose={() => dataLayer('sticky', 'linkedin')}
              >
                <Linkedin />
              </LinkedinShareButton>
            </ButtonSocialMedia>
          </StickyBox>

          <CenteredContentBlog>
            <Tag>{post.frontmatter.tags}</Tag>
            <HeaderTitle css={{ fontSize: 46 }}>{post.frontmatter.title}</HeaderTitle>
            <div css={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
              <FooterText>{post.frontmatter.date}</FooterText>
              <div css={{ width: 30 }} />
              <FooterText>--- {post.frontmatter.author}</FooterText>
            </div>
            {post.frontmatter.featuredImageCredit && (
              <FooterText
                dangerouslySetInnerHTML={{
                  __html: `Photo de couverture : <a target="_blank" rel="noreferrer noopener" href="${post.frontmatter.featuredImageLink}">${post.frontmatter.featuredImageCredit}</a>`,
                }}
              />
            )}
            <ContentBlog dangerouslySetInnerHTML={{ __html: post.html }} />
            <SubtitleDescription>{post.frontmatter.author}</SubtitleDescription>
          </CenteredContentBlog>
        </div>
      </Section>

      <Section
        theme="secondary"
        css={{
          padding: '45px 0px 130px 25px',
          [mediaQueries.phoneOnly]: {
            padding: '40px 0px 100px 25px',
          },
          [mediaQueries.desktopUp]: {
            padding: '45px 0px 130px 25px',
          },
        }}
      >
        <TitleDescription css={{ textAlign: 'center' }}>Partager l'article</TitleDescription>
        <div
          css={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 10 }}
        >
          <ButtonSocialMedia>
            <FacebookShareButton
              url={shareUrl}
              quote={title}
              className="button"
              onShareWindowClose={() => dataLayer('bottom', 'facebook')}
            >
              <Facebook />
            </FacebookShareButton>
          </ButtonSocialMedia>
          <ButtonSocialMedia>
            <TwitterShareButton
              url={shareUrl}
              title={title}
              onShareWindowClose={() => dataLayer('bottom', 'twitter')}
            >
              <Twitter />
            </TwitterShareButton>
          </ButtonSocialMedia>
          <ButtonSocialMedia>
            <LinkedinShareButton
              url={shareUrl}
              title={title}
              onShareWindowClose={() => dataLayer('bottom', 'linkedin')}
            >
              <Linkedin />
            </LinkedinShareButton>
          </ButtonSocialMedia>
        </div>
      </Section>

      <Section
        theme="primary"
        css={{
          position: 'relative',
          height: 'auto',
          [mediaQueries.tabletLandscapeUp]: {
            height: '480',
          },
        }}
      >
        <div
          css={{
            marginTop: -200,
            position: 'relative',
            [mediaQueries.phoneOnly]: {
              marginTop: -120,
            },
          }}
        >
          <RelatedPosts currentPost={post} edges={edges} isBlogPost />
        </div>
      </Section>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'NewsArticle',
            headline: post.frontmatter.title,
            image: [post.frontmatter.featuredImage.childImageSharp.gatsbyImageData.src],
            description: post.frontmatter.preview,
            datePublished: new Date(post.frontmatter.date),
            author: {
              '@type': 'Person',
              name: post.frontmatter.author,
            },
            publisher: {
              '@type': 'Organization',
              name: 'Le Reacteur',
              logo: {
                '@type': 'ImageObject',
                url: 'https://www.lereacteur.io/images/lereacteur_rond_violet.png',
              },
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': location.href,
            },
          }),
        }}
      />
    </Layout>
  );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "DD MMMM YYYY", locale: "fr")
        author
        tags
        alt
        featuredImage {
          childImageSharp {
            gatsbyImageData(width: 970)
          }
        }
        featuredImageCredit
        featuredImageLink
        preview
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "DD MMMM YYYY", locale: "fr")
            title
            author
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 970)
              }
            }
            tags
            preview
            published
            alt
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
